"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const ThumbnailStyledComponents_1 = require("./ThumbnailStyledComponents");
/**
 * Thumbnail Component
 *
 * This component is used to display a thumbnail image. A loading state and thumbnail image can be set via props.
 * Management of any image data is handled externally. If no `imageSource` is provided, the thumbnail component becomes an
 * "add button" which calls the "addThumbnail" callback function. When the `x` is clicked, the "removeThumbnail" callback function is called with an "image key"
 * argument passed in for an external delete action to consume. If the component needs to handle specialized files, the "customImageComponent" prop can be used to render a custom component.
 *
 * The default behavior is to open the image in a new tab, to change this use the "viewImage" prop.
 * Props:
 {{REWRITTEN_CODE}}
  * @param {'48' | '64'} [size='64'] - The size of the thumbnail in pixels.
  * @param {string} [imageSource] - The source URL of the image to be displayed.
  * @param {() => void} [addThumbnail] - Callback function to add a new thumbnail.
  * @param {string} imageKey - Unique key associated with the image.
  * @param {boolean} isLoading - Flag indicating whether the thumbnail is in a loading state.
  * @param {'grayCheck' | 'greenCheck' | 'redX'} [iconVariant] - Variant of the icon to be displayed on the thumbnail.
  * @param {boolean} border - Flag indicating whether the thumbnail should have a border.
  * @param {(imageSource: string) => ReactNode} [customImageComponent] - Custom component to render the image.
  * @param {(imageKey: string) => void} removeThumbnail - Callback function to remove the image.
  * @param {(imageSrc: string) => void} [viewImage] - Callback function to view the image in a new window or custom viewer.
  * @param {string} labelText - Text label displayed below the thumbnail.
 {{REWRITTEN_CODE}}
 *
 * @returns {React.FC<ThumbnailProps>} Thumbnail component.
 */
const Thumbnail = ({ size = '64', imageSource, addThumbnail, removeThumbnail, isLoading, imageKey, customImageComponent, border, iconVariant, viewImage, labelText, }) => {
    const onOverlayClicked = (0, react_1.useCallback)(() => {
        if (viewImage) {
            imageSource && viewImage(imageSource);
            return;
        }
        window.open(imageSource, '_blank');
    }, [imageSource, viewImage]);
    return (react_1.default.createElement(material_1.Box, { sx: { width: `${size}px` } },
        react_1.default.createElement(ThumbnailStyledComponents_1.ThumbnailContainer, { border: border && imageSource, size: size },
            isLoading && !iconVariant && (react_1.default.createElement(ThumbnailStyledComponents_1.LoadingContainer, null,
                react_1.default.createElement(material_1.CircularProgress, null))),
            !isLoading && imageSource && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(IconVariant, { variant: iconVariant }),
                react_1.default.createElement(ThumbnailStyledComponents_1.ThumbnailOverlay, { className: ThumbnailStyledComponents_1.thumbnailOverlay },
                    !iconVariant && react_1.default.createElement(ThumbnailStyledComponents_1.OverlayClose, { fontSize: "inherit", onClick: () => removeThumbnail(imageKey) }),
                    react_1.default.createElement(ThumbnailStyledComponents_1.SimpleButton, { onClick: onOverlayClicked },
                        react_1.default.createElement(material_1.Typography, { color: "white" }, "View"))),
                customImageComponent ? customImageComponent(imageSource) : react_1.default.createElement(ThumbnailStyledComponents_1.Image, { src: imageSource, alt: "Thumbnail" }))),
            !isLoading && !imageSource && react_1.default.createElement(AddButton, { onClick: addThumbnail })),
        labelText && (react_1.default.createElement(ThumbnailStyledComponents_1.ThumbnailLabel, { fontSize: "12px", variant: "body1" }, labelText))));
};
exports.Thumbnail = Thumbnail;
const IconVariant = (0, react_1.memo)(({ variant }) => {
    switch (variant) {
        case 'grayCheck':
            return (react_1.default.createElement(ThumbnailStyledComponents_1.IconWrapper, null,
                react_1.default.createElement(CheckCircle_1.default, { color: "disabled" })));
        case 'greenCheck':
            return (react_1.default.createElement(ThumbnailStyledComponents_1.IconWrapper, null,
                react_1.default.createElement(CheckCircle_1.default, { color: "success" })));
        case 'redX':
            return (react_1.default.createElement(ThumbnailStyledComponents_1.IconWrapper, null,
                react_1.default.createElement(Cancel_1.default, { color: "error" })));
        default:
            return null;
    }
});
const AddButton = ({ onClick }) => (react_1.default.createElement(ThumbnailStyledComponents_1.AddButtonWrapper, { onClick: onClick },
    react_1.default.createElement(icons_material_1.Add, { sx: {
            path: {
                color: '#EEE',
            },
        } })));
//# sourceMappingURL=Thumbnail.js.map